import type { ReactNode } from 'react';
import { UMButton, UMIcon } from '../../urbanmap/_components';
import { Pill } from '../proposition-c/ui';
import { fmt } from './domain';
import { HomeRail } from './HomeChrome';
import { ProjectAccessAvatars } from './ProjectAccessAvatars';
import { PC, UMR, caption } from './tokens';
import type { PlanProject } from './types';

interface HeaderProps {
  project: PlanProject;
  umChanges: number;
  onSync: () => void;
  syncOpen: boolean;
}

export function ProjectHeader({ project, umChanges, onSync, syncOpen }: HeaderProps) {
  return (
    <header
      className="pcv3-project-header"
    >
      <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, maxWidth: '100%', overflow: 'hidden' }}>
        <span style={{ fontSize: 15, fontWeight: 700, lineHeight: '20px', color: UMR.textStrong, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{project.name}</span>
        <span style={{ ...caption, display: 'flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
          <UMIcon name="content_copy" size={13} color={PC.accent} />
          Copie UrbanMap du {project.snapshotDate} · {project.perimeterLabel} · {fmt(project.buildingCount)} bâtiments
        </span>
      </div>
      <span style={{ flex: 1 }} />
      {umChanges > 0 && (
        <Pill tone="warning" icon="update" onClick={onSync} title="Voir les écarts avec UrbanMap">
          UrbanMap a évolué · {fmt(umChanges)} bâtiment{umChanges > 1 ? 's' : ''}
        </Pill>
      )}
      <Toggle on={syncOpen}><UMButton variant="secondary" icon="sync" onClick={onSync}>Synchroniser</UMButton></Toggle>
      <ProjectAccessAvatars project={project} sharing />
    </header>
  );
}

function Toggle({ on, children }: { on: boolean; children: ReactNode }) {
  return <span style={{ display: 'inline-flex', boxShadow: on ? `inset 0 -2px 0 ${PC.accent}` : undefined }}>{children}</span>;
}

export function ProjectRail({ onProjects, flash, onSettings, settingsOpen, onMap, mapActive }: {
  onProjects: () => void; flash: (message: string) => void; onSettings: () => void; settingsOpen: boolean;
  onMap: () => void; mapActive: boolean;
}) {
  return <HomeRail onHome={onProjects} flash={flash} isHome={false} projectNavigation onSettings={onSettings} settingsOpen={settingsOpen}
    onMap={onMap} mapActive={mapActive} />;
}
